import React, { useMemo } from "react";
import { ISAD_LEVELS, ISAD_CONFIG } from "../../models/isad";
import {
  computeIsadDistribution,
  deltaColor,
  formatDelta,
} from "../../utils/isadDelta";
import { PREVIOUS_CAMPAIGN_ISAD } from "../../mock/summary.mock";

const DELTA_COLORS = {
  green: "text-green-600 dark:text-green-400",
  red: "text-red-500 dark:text-red-400",
  neutral: "text-gray-400 dark:text-gray-500",
};

export default function CorridorStatus({ isadData }) {
  const current = useMemo(
    () => computeIsadDistribution(isadData),
    [isadData]
  );

  return (
    <div className="space-y-2">
      <div className="flex h-3 w-full overflow-hidden rounded-full">
        {ISAD_LEVELS.map((level) => (
          <div
            key={level}
            style={{
              width: `${current[level]}%`,
              backgroundColor: ISAD_CONFIG[level].color,
            }}
            title={`${level}: ${current[level]}%`}
          />
        ))}
      </div>

      <div className="space-y-1">
        {ISAD_LEVELS.map((level) => {
          const delta = current[level] - PREVIOUS_CAMPAIGN_ISAD[level];
          const color = deltaColor(level, delta);
          return (
            <div key={level} className="flex items-center justify-between text-xs">
              <div className="flex items-center gap-1.5">
                <span
                  className="inline-block h-2 w-2 rounded-full"
                  style={{ backgroundColor: ISAD_CONFIG[level].color }}
                />
                <span className="font-medium text-navy-700 dark:text-white">
                  {level}
                </span>
                <span className="text-gray-400 dark:text-gray-500">
                  {ISAD_CONFIG[level].label}
                </span>
              </div>
              <div className="flex items-center gap-1.5">
                <span className="font-mono text-navy-700 dark:text-white">
                  {current[level]}%
                </span>
                <span className={`font-mono ${DELTA_COLORS[color]}`}>
                  ({formatDelta(delta)} vs last)
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
